export enum CustomSearchResultSortOrder {
  MainCategory = -10,
}
